"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _Component = _interopRequireDefault(require("./Component"));

function HOC() {
  (0, _hoc.useMount)(function () {
    document.title = "".concat(process.env['REACT_APP_WEBSITE_NAME'], " - \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430");
  });
  return /*#__PURE__*/_react["default"].createElement(_Component["default"], null);
}

var _default = HOC;
exports["default"] = _default;